


const InitiationHeader = () => {
  return (
    <header className="mb-12 text-center">
      <div className="flex justify-center mb-6">
        <img 
          src="/lovable-uploads/clr_4.png" 
          alt="Bromentum Logo" 
          className="w-16 h-16 object-contain"
        />
      </div>
      <h1 className="text-4xl md:text-5xl font-marker text-tan mb-2">THE INITIATION</h1>
      <p className="text-xl font-patrick text-tan-light italic">"We weren't supposed to wake up. But we did."</p>
    </header>
  );
};

export default InitiationHeader;
